import React from 'react';
import {
    AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';

const tooltipStyle = {
    contentStyle: {
        background: '#1e293b',
        border: '1px solid #334155',
        borderRadius: '8px',
        color: '#ffffff',
        fontSize: '13px',
        direction: 'rtl',
    },
};

export default function TrendChart({ data }) {
    if (!data?.length) return <p style={{ color: '#94a3b8', textAlign: 'center', padding: '60px 0' }}>لا توجد بيانات كافية</p>;

    return (
        <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 4 }}>
                <defs>
                    <linearGradient id="trendGrad" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%"  stopColor="#00d9ff" stopOpacity={0.25} />
                        <stop offset="95%" stopColor="#00d9ff" stopOpacity={0} />
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#334155" vertical={false} />
                <XAxis
                    dataKey="date"
                    stroke="#94a3b8"
                    tick={{ fontSize: 11, fill: '#94a3b8' }}
                    tickFormatter={(v) => v?.slice(5)}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    stroke="#94a3b8"
                    tick={{ fontSize: 11, fill: '#94a3b8' }}
                    allowDecimals={false}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip
                    {...tooltipStyle}
                    formatter={(v) => [v, 'احتجاجات']}
                    cursor={{ stroke: '#334155' }}
                />
                <Area
                    type="monotone"
                    dataKey="count"
                    stroke="#00d9ff"
                    strokeWidth={2}
                    fill="url(#trendGrad)"
                    dot={false}
                    activeDot={{ r: 4, fill: '#00d9ff', stroke: '#0f172a', strokeWidth: 2 }}
                />
            </AreaChart>
        </ResponsiveContainer>
    );
}
